import * as React from 'react';
import { connect } from 'react-redux';
import { find } from 'lodash';
import * as moment from 'moment';
import { Card, Tag, Icon, Tooltip } from '../';
import conditions from '../../data/conditions';

interface Props {
  reservation: any;
  handleUpdate?: Function;
  currentDay?: any;
  link?: string | boolean;
  vehicleTypes: Array<any>;
}

/**
 * A singular reservation item used for archive views
 */
const ReservationItem = ({
  reservation,
  handleUpdate = () => {},
  currentDay = moment(),
  vehicleTypes,
  link = false,
}: Props) => {
  const start = moment(reservation.start).format('DD/MM/YY');
  const end = moment(reservation.end).format('DD/MM/YY');
  const condition = find(conditions, {
    value: parseInt(reservation.condition, 10),
  });

  // Determine if hire ends today
  let endsToday = false;
  if (['ON-HOLD', 'COMPLETE'].indexOf(reservation.status) === -1) {
    endsToday =
      moment(reservation.end).format('YYYY-MM-DD') ===
      currentDay.format('YYYY-MM-DD');
  }

  // Determine vehicle type
  const vehicleType = find(vehicleTypes, { id: reservation.vehicle_type_id });

  const duration =
    1 + moment(reservation.end).diff(moment(reservation.start), 'd');

  return (
    <Card list key={reservation.id} link={link} className="card--dark">
      <article className="media">
        <figure className="media-left has-text-centered">
          <span className="avatar image is-64x64">
            <img src={vehicleType.image} />
          </span>
          {reservation.vehicle && (
            <Tag type="warning" className="has-text-weight-bold">
              {reservation.vehicle.registration}
            </Tag>
          )}
        </figure>
        <div className="media-content">
          <div className="content">
            <small className="has-text-grey">
              {start} - {end}
              {endsToday && (
                <>
                  {' '}
                  <Tooltip text="Finishes today">
                    <span className="has-text-danger">
                      <Icon icon="exclamation-triangle" />
                    </span>
                  </Tooltip>
                </>
              )}
            </small>
            <br />
            <strong>{reservation.name}</strong>
            <br />
            {vehicleType.name} Reservation for {duration} day
            {duration !== 1 && 's'}
            {!!reservation.description && (
              <>
                <br />
                <small>{reservation.description}</small>
              </>
            )}
          </div>
        </div>
        <div className="media-right">
          <div className="field is-grouped is-grouped-right">
            <span className="control">
              <Tooltip text="Vehicle cannot be booked during this period">
                <Tag type="dark">{reservation.type}</Tag>
              </Tooltip>
            </span>
            <span className="control">
              <Tooltip text="Vehicle's condition">
                {/* <Tag type="dark">{reservation.condition}</Tag> */}
                {reservation.condition > 0 && condition !== undefined && (
                  <span className={`tag is-${condition.class}`}>
                    {condition.name}
                  </span>
                )}
              </Tooltip>
            </span>
          </div>
        </div>
      </article>
    </Card>
  );
};

const mapStateToProps = ({ vehicleTypes }) => ({
  vehicleTypes: vehicleTypes.vehicleTypes,
});

export default connect(mapStateToProps)(ReservationItem);
